export const ACCEPT_SUGGESTION = 'ACCEPT_SUGGESTION';
export const DELETE_SUGGESTIONS_BY_ELEMENTS_IDS =
  'DELETE_SUGGESTIONS_BY_ELEMENTS_IDS';
export const DISMISS_SUGGESTION = 'DISMISS_SUGGESTION';
export const UPDATE_LOADING_STATE = 'UPDATE_LOADING_STATE';
export const UPDATE_SUGGESTIONS = 'UPDATE_SUGGESTIONS';
